import React from "react";
import baseContentLayout from "../../shared/base-content/index";
import "./index.scss";
import MyButton from "../../shared/buttons/primary";
import * as actions from "../../../modules/setting/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";
import DeleteDialog from "./dialog/delete";

const Content = (props) => {
  const { dispatchActions, setting, auth } = props;
  const [listParticipant, setListParticipant] = React.useState([]);
  const [isUpdateRecord, setIsUpdateRecord] = React.useState(null);
  const [isCreateRecord, setIsCreateRecord] = React.useState(null);
  const [errorMessage, setErrorMessage] = React.useState({});
  const [isOpenDeleteModal, setIsOpenDeleteModal] = React.useState({
    data: null,
    isShow: false,
  });

  React.useEffect(() => {
    setListParticipant(setting.listParticipants);
  }, [setting.listParticipants]);

  const deleteBtnClick = (data) => {
    setIsOpenDeleteModal({
      data,
      isShow: true,
    });
  };

  React.useEffect(() => {
    reloadSeat();
  }, []);

  const reloadSeat = () => {
    dispatchActions.getListParticipants(auth.user.id);
  };

  const editBtnClick = (item) => {
    setIsUpdateRecord({
      id: item.id,
      value: item.seat_no,
    });
  };

  const handleChangeInput = (e) => {
    const { value, name } = e.target;
    if (String(value).length > 5) return;
    if (name === "create_seat") {
      setIsCreateRecord(Number(value));
    } else {
      setIsUpdateRecord({
        ...isUpdateRecord,
        value: Number(value),
      });
    }
  };

  const renderSeatInput = (value, name) => {
    return (
      <div className="text-start">
        <div className="create-seat-input d-flex align-items-center gap-3">
          <input
            type="number"
            className="form-control"
            placeholder="人数"
            inputMode="decimal"
            value={value || ""}
            name={name}
            maxLength="5"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            onChange={handleChangeInput}
          />
          人
        </div>
        {getFormMessage(name)}
      </div>
    );
  };

  const getFormMessage = React.useCallback(
    (name) => {
      const error = errorMessage[name];
      if (!error) return null;
      return <p className="error-text">{error}</p>;
    },
    [errorMessage]
  );

  const renderSeat = React.useCallback(
    (item) => {
      if (item.id !== isUpdateRecord?.id) return `${item.seat_no}人`;

      return renderSeatInput(
        isUpdateRecord.value,
        `update_seat_${isUpdateRecord.id}`
      );
    },
    [isUpdateRecord, errorMessage]
  );

  const handleValidate = (action, value) => {
    let seats = cloneDeep(listParticipant);
    let errorMessageKey = "create_seat";
    if (action === "edit") {
      seats = seats.filter((seat) => seat.id !== isUpdateRecord.id);
      errorMessageKey = `update_seat_${isUpdateRecord.id}`;
    }

    if (!value) {
      setErrorMessage({
        [errorMessageKey]: "席数を入力してください。",
      });
      return false;
    }

    const isExited = seats.findIndex((seat) => seat.seat_no === value);
    if (isExited >= 0) {
      setErrorMessage({
        [errorMessageKey]: "この人数は既に存在しています。",
      });
      return false;
    }

    return true;
  };

  const handleSaveUpdate = () => {
    const isPass = handleValidate("edit", isUpdateRecord.value);
    if (isPass) {
      window
        .axios({
          url: `/seat/${isUpdateRecord.id}/`,
          method: "PUT",
          data: {
            seat_no: isUpdateRecord.value,
            shop: auth.user.id,
          },
        })
        .then((result) => {
          if (result.data) {
            setIsUpdateRecord(null);
            reloadSeat();
            setErrorMessage({});
          }
        });
    }
  };

  const handleSaveCreate = () => {
    const isPass = handleValidate("create", isCreateRecord);
    if (isPass) {
      window
        .axios({
          url: "/seat/",
          method: "POST",
          data: {
            seat_no: isCreateRecord,
            shop: auth.user.id,
          },
        })
        .then((result) => {
          if (result.data) {
            setIsCreateRecord(null);
            reloadSeat();
            setErrorMessage({});
          }
        });
    }
  };

  const handleRemoveCreateItem = () => {
    setIsCreateRecord(null);
  };

  const handleRemoveEditSeat = () => {
    setIsUpdateRecord(null);
  };

  const handleAddSeat = () => {
    setIsCreateRecord(0);
  };

  const onCloseDeleteDialog = (data) => {
    setIsOpenDeleteModal({
      data: null,
      isShow: false,
    });
    if (!window.utils.isEmptyObject(data)) {
      reloadSeat();
    }
  };

  const renderSaveBtn = (action) => {
    const clickSaveMethod =
      action === "edit" ? handleSaveUpdate : handleSaveCreate;
    const clickCloseMethod =
      action === "edit" ? handleRemoveEditSeat : handleRemoveCreateItem;
    return (
      <>
        <button
          type="button"
          className="me-2 btn btn-sm btn-info"
          onClick={clickSaveMethod}
        >
          <i className="fas fa-save"></i>
        </button>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={clickCloseMethod}
        >
          <i className="fas fa-times"></i>
        </button>
      </>
    );
  };

  const renderEditBtn = React.useCallback(
    (item) => {
      if (item.id !== isUpdateRecord?.id)
        return (
          <>
            <button
              type="button"
              className="me-2 btn btn-sm btn-primary"
              onClick={() => editBtnClick(item)}
            >
              <i className="fas fa-pen"></i>
            </button>
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => deleteBtnClick(item)}
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          </>
        );
      return renderSaveBtn("edit");
    },
    [isUpdateRecord]
  );

  const renderRowBody = () => {
    if (listParticipant?.length) {
      return listParticipant.map((item) => (
        <tr key={item.id}>
          <td>{renderSeat(item)}</td>
          <td className="buttons">{renderEditBtn(item)}</td>
        </tr>
      ));
    }
  };

  return (
    <div className="table-participants">
      <div
        className="history__table table-participants__table"
        style={{
          maxWidth: 500,
          margin: "0 auto",
        }}
      >
        <table className="table">
          <thead className="">
            <tr>
              <th scope="col" className="col-seats">
                人数
              </th>
              <th scope="col" className="col-actions">
                操作
              </th>
            </tr>
          </thead>
          <tbody>
            {renderRowBody()}
            {isCreateRecord !== null && (
              <tr>
                <td>{renderSeatInput(isCreateRecord, "create_seat")}</td>
                <td className="buttons">{renderSaveBtn("create")}</td>
              </tr>
            )}
            {!listParticipant?.length && isCreateRecord === null && (
              <tr>
                <td colSpan="5">データなし</td>
              </tr>
            )}
          </tbody>
        </table>
        <MyButton
          disabled={isCreateRecord !== null}
          className="mt-2"
          myVariant="add"
          onClick={handleAddSeat}
        >
          ＋ 追加
        </MyButton>
      </div>
      {isOpenDeleteModal.isShow && (
        <DeleteDialog
          isShow={isOpenDeleteModal.isShow}
          onClose={onCloseDeleteDialog}
          data={isOpenDeleteModal.data}
        />
      )}
    </div>
  );
};
const ParticipantsContent = baseContentLayout(Content);

class Container extends React.Component {
  render() {
    return <ParticipantsContent name="人数" {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    setting: state.setting,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
